export default "__VITE_ASSET__CFOJm4lX__"